module.exports = __webpack_public_path__ + "static/img/khk003.46fe4215.jpg";